import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uix/uix/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "action-bar"
    }}>{`Action Bar`}</h1>
    <p>{`The Action Bar is an area above the content fragment list in the `}<a parentName="p" {...{
        "href": "../../"
      }}>{`Content Fragments Console`}</a>{` that displays action items that can be executed on selected content fragments. These actions may include editing, deleting, exporting, cloning, or publishing content fragments, and the Action Bar appears over the `}<a parentName="p" {...{
        "href": "../header-menu"
      }}>{`Header Menu`}</a>{` when one or multiple content fragments are selected.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.12500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/4a8493658edded4712e63e3555cf342a/5530d/action-bar.webp 320w", "/uix/docs/static/4a8493658edded4712e63e3555cf342a/0c8fb/action-bar.webp 640w", "/uix/docs/static/4a8493658edded4712e63e3555cf342a/80c60/action-bar.webp 1000w"],
            "sizes": "(max-width: 1000px) 100vw, 1000px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/4a8493658edded4712e63e3555cf342a/dd4a7/action-bar.png 320w", "/uix/docs/static/4a8493658edded4712e63e3555cf342a/0f09e/action-bar.png 640w", "/uix/docs/static/4a8493658edded4712e63e3555cf342a/1263b/action-bar.png 1000w"],
            "sizes": "(max-width: 1000px) 100vw, 1000px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/4a8493658edded4712e63e3555cf342a/1263b/action-bar.png",
            "alt": "Action Bar",
            "title": "Action Bar",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Action bar can be customized via methods defined in `}<inlineCode parentName="p">{`actionBar`}</inlineCode>{` namespace.`}</p>
    <p>{`You have the ability to:`}</p>
    <ul>
      <li parentName="ul">{`create multiple buttons from single extension;`}</li>
      <li parentName="ul">{`implement drop-down menu buttons;`}</li>
      <li parentName="ul">{`use any `}<a parentName="li" {...{
          "href": "https://react-spectrum.adobe.com/react-spectrum/workflow-icons.html#available-icons"
        }}>{`icon`}</a>{` from React Spectrum;`}</li>
      <li parentName="ul">{`delete default or added by extension buttons;`}</li>
    </ul>
    <h2 {...{
      "id": "custom-button-with-callback"
    }}>{`Custom button with callback`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { register } from "@adobe/uix-guest";

// ...

const guestConnection = await register({
    id: "my.company.extension-with-action-bar-button",
    methods: {
        actionBar: {
            getButtons() {
                return [
                    {
                        id: "my.company.export-button",
                        label: "Export",
                        icon: 'Export',
                        onClick: (selections) => {
                            console.log('Export button has been pressed', selections);
                        },
                    },
                ];
            },
        },
    },
});
`}</code></pre>
    <p>{`The callback is invoked when user clicks on the button and receives list of content fragments selected in the list.`}</p>
    <h2 {...{
      "id": "custom-button-with-sub-menu"
    }}>{`Custom button with sub menu`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { register } from "@adobe/uix-guest";

// ...

const guestConnection = await register({
    id: "my.company.extension-with-action-bar-button",
    methods: {
        actionBar: {
            getButtons() {
                return [
                    {
                        id: "my.company.export-button",
                        label: "Export",
                        icon: 'Export',
                        subItems: [
                            {
                                id: 'xml',
                                label: 'XML',
                                onClick: (selections) => {
                                    console.log('Export in XML button has been pressed.', selections);
                                    // ...
                                },
                            },
                            {
                                id: 'csv',
                                label: 'CSV',
                                onClick: (selections) => {
                                    console.log('Export in CSV button has been pressed.', selections);
                                    // ...
                                },
                            },
                        ],
                    },
                ];
            },
        },
    },
});
`}</code></pre>
    <p>{`The callback is invoked when user clicks on the button and receives list of content fragments selected in the list.`}</p>
    <h2 {...{
      "id": "delete-button"
    }}>{`Delete button`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { register } from "@adobe/uix-guest";

// ...

const guestConnection = await register({
    id: "my.company.extension-with-action-bar-button",
    methods: {
        actionBar: {
            deleteButtons() {
                return [
                    {
                        //The "id" property is the "data-id" property of html button element.
                        id: "my.company.export-button"
                    },
                ];
            },
        },
    },
});
`}</code></pre>
    <h2 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h2>
    <h3 {...{
      "id": "button-api"
    }}>{`Button API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Must be unique`}</strong>{` across all extensions. Consider adding a vendor prefix to this field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Button label that will be visible on UI`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of a `}<a parentName="td" {...{
              "href": "https://react-spectrum.adobe.com/react-spectrum/workflow-icons.html#available-icons"
            }}>{`React-Spectrum workflow icon`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`subItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list with sub menu items`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onClick`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callback(selections): void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback for a button `}<inlineCode parentName="td">{`onClick`}</inlineCode>{` event. Receives list of content fragments selected in the list`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "sub-menu-item-api"
    }}>{`Sub menu item API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Must be unique`}</strong>{` across the current button sub menu`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Button label that will be visible on UI`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of a `}<a parentName="td" {...{
              "href": "https://react-spectrum.adobe.com/react-spectrum/workflow-icons.html#available-icons"
            }}>{`React-Spectrum workflow icon`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onClick`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callback(selections): void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback for a button `}<inlineCode parentName="td">{`onClick`}</inlineCode>{` event. Receives list of content fragments selected in the list`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "delete-button-api"
    }}>{`Delete button API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"id" is a "data-id" attribute of the button (please use browser developer console to find actual value).`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "get-list-of-selected-fragments"
    }}>{`Get List of selected Fragments`}</h3>
    <p>{`You can access data about the currently selected Content Fragments using the `}<inlineCode parentName="p">{`host.fragmentSelections.getSelections()`}</inlineCode>{` method in an extension.`}</p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples:`}</h2>
    <h3 {...{
      "id": "buttons-conditional-rendering"
    }}>{`Buttons conditional rendering`}</h3>
    <p>{`Content Fragment Admin invokes the getButtons method each time a user changes the content fragments selection. Therefore, you can dynamically return different sets of buttons based on the data that has changed on the page.
For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { register } from "@adobe/uix-guest";

// ...

const guestConnection = await register({
    id: "my.company.extension-with-action-bar-button",
    methods: {
        actionBar: {
            async getButtons() {
                const selections = await guestConnection?.host?.fragmentSelections?.getSelections?.() || [];
                const defaultButtons = [
                    {
                        id: "default_btn",
                        label: "Default Button",
                        onClick(selections) {}
                    }
                ]

                if (selections.length > 1 ) {
                    return [
                        ...defaultButtons,
                        {
                            id: "two_and_more_selected",
                            label: "Ext two and more selected",
                        }
                    ]
                }

                return [
                    ...defaultButtons,
                    {
                        id: "one_or_less_selected",
                        label: "Ext one or less selected",
                    }
                ]
            },
        },
    },
});
`}</code></pre>
    <p>{`The defaultButtons constant contains the buttons that will be rendered every time, regardless of the condition.
On the line `}<inlineCode parentName="p">{`const selections = await guestConnection?.host?.fragmentSelections?.getSelections?.() || []`}</inlineCode>{`;
we get information about the current list of selected content fragments.`}</p>
    <p>{`Based on the quantity of selected content fragments, we render different sets of buttons.`}</p>
    <p>{`In case if selected more then one content fragment (`}<inlineCode parentName="p">{`selections.length > 1`}</inlineCode>{`) the default buttons and button with id "two_and_more_selected" will be rendered
In case if selected just one content fragment the default button and button with id "one_or_less_selected" will be rendered`}</p>
    <p>{`This technique allows for building complex logic behind the button rendering.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      